import type { EntryV2 } from 'services/cms/typesUtil';

/**
 * Calculates the component key; useful for rendering entry components in a loop
 */
export function componentKeyV2<T>(entry: EntryV2<T>, index: number) {
  return [entry.id, index].join('.');
}
